import './BiosecurityWebSeries/Resources/resources.css'

const Resources = ({ resources }) => {
    return (
        <ul className='additional-resources' >
            <h3> Additional Resources: </h3>
            {
                resources.map(resource => <li onClick={() => window.open(`${resource.link}`)}> {resource.title}  </li>)
            }
        </ul>
    )
}

export default Resources;